import { IProps } from './index'

const C50I = ({ onConnect, onCancel }: IProps) => {
  return (
    <div
      className="reader-view"
      data-reader-view="device-instructions"
      data-device-type="c50i"
    >
      <h3 className="mb-6">
        <i className="fa fa-plug"></i>
        Instructions for connecting to your device
      </h3>
      <ul className="text-left">
        <li>
          <span>1</span> Be sure the C50i USB cable is connected securely to
          your computer.
        </li>
        <li>
          <span>2</span> Press the power button on the side of the oximeter
          opposite the USB connector until it powers on.
        </li>
        <li className="warning">
          <span>3</span> <small>IMPORTANT:</small> Be sure the display reads
          "Finger Out" before resetting the oximeter.
        </li>
      </ul>

      <div className="flex justify-center items-center space-x-2 my-6">
        <button className="btn btn-default" onClick={onCancel}>
          <i className="fa fa-reply"></i>
          Reset Another Device
        </button>
        <button className="btn btn-primary" onClick={onConnect}>
          <i className="fa fa-download"></i>
          Reset Oximeter
        </button>
      </div>
    </div>
  )
}

export default C50I
